module.exports = __webpack_public_path__ + "img/item-3-3.3c434f9b.png";